@if (hasSteps() && variant() === 'compact') {
  <div class="ui-step-progress ui-step-progress--compact" role="group" [attr.aria-label]="ariaLabel()">
    @if (activeStep(); as step) {
      <div
        class="ui-step-progress__step ui-step-progress__step--compact"
        [class.ui-step-progress__step--completed]="step.status === 'completed'"
        [class.ui-step-progress__step--current]="step.status === 'current'"
        [class.ui-step-progress__step--pending]="step.status === 'pending'"
        [class.ui-step-progress__step--error]="step.status === 'error'"
      >
        <span class="ui-step-progress__marker" aria-hidden="true">
          @if (step.iconSrc) {
            <img class="ui-step-progress__icon-img" [src]="step.iconSrc" alt="" />
          } @else if (step.status === 'completed') {
            <svg class="ui-step-progress__icon" viewBox="0 0 24 24" focusable="false">
              <path d="M20 6 9 17l-5-5" />
            </svg>
          } @else if (step.status === 'error') {
            <svg class="ui-step-progress__icon" viewBox="0 0 24 24" focusable="false">
              <path d="M12 8v5m0 4h.01" />
            </svg>
          } @else if (showStepNumber()) {
            <span class="ui-step-progress__number">{{ activeIndex() + 1 }}</span>
          } @else {
            <span class="ui-step-progress__dot"></span>
          }
        </span>

        <span class="ui-step-progress__body ui-step-progress__body--compact">
          <span class="ui-step-progress__eyebrow">Paso {{ activeIndex() + 1 }} de {{ totalSteps() }}</span>
          <span class="ui-step-progress__compact-row">
            <span class="ui-step-progress__label ui-step-progress__label--compact">{{ step.label }}</span>
            @if (showStatusLabel()) {
              <span class="ui-step-progress__status ui-step-progress__status--compact">
                {{ step.helperText || statusLabel(step.status) }}
              </span>
            }
          </span>
        </span>
      </div>

      <div
        class="ui-step-progress__bar"
        role="progressbar"
        [attr.aria-valuenow]="progressPercent()"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-label]="ariaLabel()"
      >
        <span class="ui-step-progress__bar-fill" [style.width.%]="progressPercent()"></span>
      </div>
    }
  </div>
} @else if (hasSteps()) {
  <nav class="ui-step-progress" [attr.aria-label]="ariaLabel()">
    <ol class="ui-step-progress__list">
      @for (step of steps(); track step.id; let index = $index; let last = $last) {
        <li class="ui-step-progress__item">
          @if (interactive()) {
            <button
              type="button"
              class="ui-step-progress__step"
              [class.ui-step-progress__step--completed]="step.status === 'completed'"
              [class.ui-step-progress__step--current]="step.status === 'current'"
              [class.ui-step-progress__step--pending]="step.status === 'pending'"
              [class.ui-step-progress__step--error]="step.status === 'error'"
              [attr.aria-current]="isCurrent(step) ? 'step' : null"
              [attr.aria-label]="stepAriaLabel(step, index)"
              (click)="onStepSelect(step)"
            >
              <ng-container
                *ngTemplateOutlet="stepContent; context: { step: step, index: index }"
              />
            </button>
          } @else {
            <div
              class="ui-step-progress__step"
              [class.ui-step-progress__step--completed]="step.status === 'completed'"
              [class.ui-step-progress__step--current]="step.status === 'current'"
              [class.ui-step-progress__step--pending]="step.status === 'pending'"
              [class.ui-step-progress__step--error]="step.status === 'error'"
              [attr.aria-current]="isCurrent(step) ? 'step' : null"
              [attr.aria-label]="stepAriaLabel(step, index)"
              role="group"
            >
              <ng-container
                *ngTemplateOutlet="stepContent; context: { step: step, index: index }"
              />
            </div>
          }

          @if (!last) {
            <span
              class="ui-step-progress__connector"
              [class.ui-step-progress__connector--completed]="connectorState(index) === 'completed'"
              [class.ui-step-progress__connector--current]="connectorState(index) === 'current'"
              [class.ui-step-progress__connector--pending]="connectorState(index) === 'pending'"
              [class.ui-step-progress__connector--error]="connectorState(index) === 'error'"
              aria-hidden="true"
            ></span>
          }
        </li>
      }
    </ol>
  </nav>
}

<ng-template #stepContent let-step="step" let-index="index">
  <span class="ui-step-progress__marker" aria-hidden="true">
    @if (step.iconSrc) {
      <img class="ui-step-progress__icon-img" [src]="step.iconSrc" alt="" />
    } @else if (step.status === 'completed') {
      <svg class="ui-step-progress__icon" viewBox="0 0 24 24" focusable="false">
        <path d="M20 6 9 17l-5-5" />
      </svg>
    } @else if (step.status === 'error') {
      <svg class="ui-step-progress__icon" viewBox="0 0 24 24" focusable="false">
        <path d="M12 8v5m0 4h.01" />
      </svg>
    } @else if (showStepNumber()) {
      <span class="ui-step-progress__number">{{ index + 1 }}</span>
    } @else {
      <span class="ui-step-progress__dot"></span>
    }
  </span>

  <span class="ui-step-progress__body">
    <span class="ui-step-progress__eyebrow">Paso {{ index + 1 }}</span>
    <span class="ui-step-progress__label">{{ step.label }}</span>
    @if (showStatusLabel()) {
      <span class="ui-step-progress__status">{{ step.helperText || statusLabel(step.status) }}</span>
    }
  </span>
</ng-template>
